import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { fg } from '@atlassian/jira-feature-gating';
import { FormattedMessage } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import imageUrl from './assets/empty.svg';
import messages from './messages.tsx';

type Props = Intl;
function Empty({ intl: { formatMessage } }: Props) {
	// https://ecosystem.atlassian.net/browse/AK-4581
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const description: string = (
		<FormattedMessage
			{...messages.description}
			values={{
				viewAllIssues: (
					<b>
						{formatMessage(
							fg('jira-issue-terminology-update-m4')
								? messages.viewAllIssuesIssueTerminologyRefreshM4
								: messages.viewAllIssues,
						)}
					</b>
				),
				saveFilterAs: <b>{formatMessage(messages.saveFilterAs)}</b>,
			}}
		/> // eslint-disable-next-line @typescript-eslint/no-explicit-any
	) as any;
	return (
		<EmptyState
			imageUrl={imageUrl}
			header={formatMessage(messages.header)}
			description={description}
			headingLevel={2}
		/>
	);
}
export default injectIntl(Empty);
